module.exports = __webpack_public_path__ + "static/media/GRAPHIC_Fix-a-Drink_logo.c453a0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/NavigationBar/GRAPHIC_Fix-a-Drink_logo.png
// module id = 380
// module chunks = 0